<script>
/**
 * @Author: zhangxiaojian
 * @Date: 2025/6/26
 * @LastEditors: zhangxiaojian
 * @Description 会话历史记录
 **/

import { AIDify } from '@apis'
export default {
  name: 'History',
  data() {
    return {
      isLoading: true,
      loadError: false, // 是否加载失败
      historyList: [] // 历史记录列表
    }
  },
  emits: [
    /**
     * 加载历史记录
     * @param {Array} list 对话列表
     */
    'loadHistory',
    /**
     * 更新历史记录条数
     * @param {Number} count 历史记录条数
     */
    'refreshHistoryCount'
  ],
  mounted() {
    this.getHistoryList()
  },
  methods: {
    /**
     * 获取历史记录列表
     * @returns {Promise<void>}
     */
    async getHistoryList() {
      try {
        this.loadError = false
        const res = await AIDify.conversations()
        this.isLoading = false
        if (res.status === 200 && res.data.status === 0) {
          this.historyList = res.data.data
          this.$emit('refreshHistoryCount', res.data.data.length)
        } else {
          this.historyList = []
          this.$emit('refreshHistoryCount', 0)
        }
      } catch (e) {
        this.loadError = true
      }
    },
    /**
     * 获取历史记录详情
     * @param item {Object} 历史记录信息
     * @returns {Promise<void>}
     */
    async getHistoryInfo(item) {
      try {
        const res = await AIDify.messagesInfo({
          params: {
            conversationId: item.id
          }
        })
        if (res.data.status === 0) {
          // 获取数据成功
          let list = [
            {
              // 拼接用户信息
              isUser: true,
              id: item.id,
              content: item.name
            },
            {
              // 拼接回答信息
              isUser: false,
              id: Date.now(),
              isLoading: false, // 是否开始接收数据
              isDone: true, // 是否回答完成
              content: res.data.data.answer,
              articles: res.data.data.articles // 引用的文章列表
            }
          ]
          this.$emit('loadHistory', list)
        } else {
          this.$message.error(res.data.message)
        }
      } catch (e) {
        console.error(e)
      }
    },
    /**
     * 删除历史记录
     * @param {Object} item  历史记录信息
     * @param {Number} index 所在索引
     * @returns {Promise<void>}
     */
    async deleteHistory(item, index) {
      let res = await AIDify.deleteMessage({
        params: {
          conversationId: item.id
        }
      })
      if (res.data.status === 0) {
        this.historyList.splice(index, 1)
        this.$message.success('删除成功')
        this.$emit('refreshHistoryCount', this.historyList.length)
      } else {
        this.$message.error(res.data.message)
      }
    }
  }
}
</script>

<template>
  <div :class="`message-history ${isLoading ? 'message-loading' : ''}`">
    <template v-if="!isLoading">
      <template v-if="historyList.length > 0">
        <div
          class="message-history-group"
          v-for="(item, index) in historyList"
          :key="item.id"
        >
          <div @click="() => getHistoryInfo(item)">{{ item.name }}</div>
          <i
            @click.prevent="() => deleteHistory(item, index)"
            class="delete-icon el-icon-delete"
          ></i>
        </div>
      </template>
      <template v-else>
        <div class="message-history-empty">
          <img src="../../../assets/img/empty.png" />
          <span>当前暂无历史记录</span>
        </div>
      </template>
    </template>
    <template v-else>
      <template v-if="!loadError">
        <span class="el-icon-loading"></span>
        <span style="margin-left: 5px">数据正在加载中，请稍后... </span>
      </template>
      <template v-else>
        <span @click="getHistoryList" style="cursor: pointer">
          <span>数据加载失败，请重试</span>
          <span class="el-icon-refresh"></span>
        </span>
      </template>
    </template>
  </div>
</template>

<style scoped lang="scss">
.message-history {
  padding: 10px;
  margin-top: 20px;
  flex: 2;
  overflow: auto;
  &-empty {
    text-align: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    align-items: center;
    img {
      width: 40%;
      margin-bottom: 10px;
    }
  }
  &.message-loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-group {
    margin-bottom: 13px;
    border-radius: 8px;
    padding: 5px 7px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
    display: flex;
    justify-content: space-between;
    .delete-icon {
      opacity: 0;
      pointer-events: none;
    }
    &:hover {
      background: #e1effa;
      .delete-icon {
        opacity: 1;
        pointer-events: all;
      }
    }
  }
}
</style>
